<template>
  <div data-app>
    <router-view/>
  </div>
</template>


<script>
  import FooterVue from './components/Footer.vue';
  import SocketioService from './services/socketio.services';
  import boasVindasServices from './services/boasVindas.services';
  import { extrairCores, aplicarCoresNoDOM } from './utils/cores';
  export default {
    components: {
      FooterVue,
    },
    data() {
      return {

      }
    },
    created() {
    SocketioService.setupSocketConnection();
    this.restaurarCores();
    },
    methods: {
      // O store Vuex é em memória e some no reload, e as CSS vars só eram
      // aplicadas no BoasVindas. Aqui, no boot de QUALQUER rota, rebuscamos as
      // cores no backend (fonte da verdade, via token de sessão) e reaplicamos.
      async restaurarCores() {
        if (!localStorage.getItem('tokenAuthorization')) return;
        try {
          const idioma = localStorage.getItem('idioma') || 'pt-BR';
          const resp = await boasVindasServices.buscar({ idioma });
          const cores = extrairCores(resp.data);
          aplicarCoresNoDOM(cores);
          this.$store.commit('storeCoresWebCheckin', cores);
        } catch (e) {
          console.error('Erro ao restaurar cores no boot', e);
        }
      },
    },
    beforeUnmount() {
    SocketioService.disconnect();
  }
  }

</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,600;1,100;1,200;1,300;1,400;1,500&display=swap');
body {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Poppins', sans-serif;
}
</style>
